import { GridColDef } from "@mui/x-data-grid-pro";
import { Button, IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../../common/components/primary_button";

/**
 * GenerateObrasColumnDefinition
 */

type Props = {
  onActionExportar: (idObra: number | null, openState: boolean) => void;
  onActionEditar: (idObra: number | null, openNewTab: boolean) => void;
  onActionDeletar: (idObra: number | null, openState: boolean) => void;
  onActionCopiar: (idObra: number | null, openState: boolean) => void;
  onActionEnviarEmail: (idObra: number | null, openState: boolean) => void;
  onActionIrPara: (idObra: number | null, openState: boolean) => void;
};

export const GenerateObrasColumnDefinition = ({
  onActionExportar,
  onActionEditar,
  onActionDeletar,
  onActionCopiar,
  onActionEnviarEmail,
  onActionIrPara,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 0:
        return "A";
      case 1:
        return "F";
      case 2:
        return "p";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 0:
        return "green";
      case 1:
        return "red";
      case 2:
        return "yellow";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Em Andamento";
      case 1:
        return "Finalizada";
      case 2:
        return "Paralisada";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 75,
      width: 75,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)} />
        </div>
      )
    },
    {
      field: "cadastros",
      filterable: false,
      headerName: "Cadastros",
      width: 120,
      minWidth: 120,
      sortable: false,
      headerClassName: 'funcionarios-header',
      valueGetter: (_, row) => { return row['idObra'] as number; },
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <PrimaryButton
            buttonColor="secondary"
            size="small"
            onClick={() => onActionIrPara(params.value, true)}>
            Ir para...
          </PrimaryButton>
        </div>
      )
    },
    {
      field: "empreendimento",
      filterable: false,
      headerName: "Empreendimento",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "centroCusto",
      filterable: false,
      headerName: "Centro de Custo",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
    },
    {
      field: "exportar",
      filterable: false,
      headerName: "Exportar",
      sortable: false,
      width: 160,
      minWidth: 160,
      valueGetter: (_, row) => { return row['idObra'] as number; },
      renderCell: ({ value }) => {
        return (
          <Button
            onMouseDown={() => onActionExportar(value, true)}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.2rem solid #45b6af',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
            }}>
            Plano de Qualidade
          </Button>
        );
      },
    },
    {
      field: 'idObra',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                if (e.button === 1) {
                  onActionEditar(params.value, true);
                } else {
                  onActionEditar(params.value, e.ctrlKey);
                }
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
    {
      field: 'copiar',
      sortable: false,
      filterable: false,
      headerName: 'Copiar',
      width: 65,
      valueGetter: (_, row) => row['idObra'] as number,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionCopiar(params.value, true)}>
              <DynamicIcon nameIcon="ContentCopy" size={25} className="text-purple-500" />
            </IconButton>
          </div>
        );
      }
    },
    {
      field: 'email',
      sortable: false,
      filterable: false,
      headerName: 'Enviar Email',
      width: 65,
      valueGetter: (_, row) => row['idObra'] as number,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEnviarEmail(params.value, true)}>
              <DynamicIcon nameIcon="EmailOutlined" size={25} className="text-[#009C4E]" />
            </IconButton>
          </div>
        );
      }
    }
  ];
}